import React, { useState, useEffect} from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardContent,
  CardActions,
  Divider,
  LinearProgress,
  Box,
  Typography,
  Icon,
} from "@material-ui/core";

import IconButton from "@material-ui/core/IconButton";
import CancelPresentationOutlinedIcon from "@material-ui/icons/CancelPresentationOutlined";
import CloseIcon from "@material-ui/icons/Close";

import ErrorIcon from "@material-ui/icons/WarningRounded";

import { getRequest } from "../../services/Requests";
import { Button } from "../button";
import { translate } from "../../translations/translate";

import StyledStoreCard from "./StoreCard.style";

const convertMinutes = (time) => Math.floor(time / 60000);

const convertSeconds = (time) => {
  const seconds = ((time % 60000) / 1000).toFixed(0);
  const psec = (Number(seconds) < 10 ? seconds.padStart(1, "0") : seconds);
  return psec;
};

export const StoreCard = ({ onClose, storeId, history }) => {
  const [ loading, setLoading ] = useState(true);

  const [ storeData, setData ] = useState<any>({});

  useEffect(() => {
    getRequest({ url: `public/store/${storeId}` }).then(({ data }) => {
      setData(data);
      setLoading(false);
    });
    let interval: any = setInterval(() => {
      getRequest({ url: `public/store/${storeId}` }).then(({ data }) => setData(data));
    }, 5000);
    return () => {
      clearInterval(interval);
      interval = undefined;
    };
  }, []);
  const {
    averageWaitTime = 0,
    bookingActivated = 0,
  } = storeData;

  if (loading) return null;

  const maxCapacity = storeData.current >= storeData.maxPersons;
  const progress = maxCapacity ? 100 : (storeData.current / storeData.maxPersons) * 100;

  return (<StyledStoreCard>
    <Card elevation={4} >
      <CardHeader
        className="card-header"
        title={storeData.name}
        titleTypographyProps={{
          variant: "body1",
          color: "primary",
        }}
        subheader={storeData.address}
        subheaderTypographyProps={{
          variant: "caption",
        }}
        action={
          <IconButton className="close-button" color="primary" onClick={onClose} aria-label="settings" >
            <CloseIcon />
          </IconButton>
        }
      />
      <Divider light />
      <CardContent
        className="card-content"
      >
        <Box mt={2} alignItems="center" justifyContent="center" >
          <Typography
            color="primary"
            variant="body2"
          >
            {translate("capacity")}: <Typography variant="body1" display="inline" > {storeData.current} / {storeData.maxPersons} </Typography>
          </Typography>
        </Box>
        <Box mt={2} >
          <LinearProgress variant="determinate" value={progress} />
        </Box>
        {maxCapacity ? (
          <Box flexDirection="row" justifyContent="center" alignItems="center" mt={2} >
            <Icon className="warning-icon" color="error">
              <ErrorIcon />
            </Icon>
            <Typography color="error" variant="caption"> {translate("max-capacity-warning")} </Typography>
          </Box>
        ) : null}
      </CardContent>
      <Divider light />
      <CardActions>
        {bookingActivated === 0 ? (
          <Typography color="textSecondary" variant="caption" > {translate("no-booking")} </Typography>
        ) : (
          <Link
            to={`register/${storeId}`}
          >
            <Button
              label="Book Now"
              variant="outlined"
            />
          </Link>
        )}
      </CardActions>
    </Card>
  </StyledStoreCard>);
};
